import { render, staticRenderFns } from "./icon-png.vue?vue&type=template&id=353a8fa0&"
import script from "./icon-png.vue?vue&type=script&lang=js&"
export * from "./icon-png.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports